import React from 'react';

import { cx } from '@travel/utils';

import { PLAN_PAYMENT_MANAGEMENT_NAME, SP_PAYMENT_MANAGEMENT_NAME } from 'constants/provider';
import type { PlanPaymentRestrictionFeature, SalesPromotion } from 'ProviderRatePlan-Types';

import styles from './priceLabel.module.scss';

type Props = {
  className?: string;
  /** Object of sales promotion*/
  salesPromotion?: SalesPromotion;
  /** Object of Plan payment restriction  */
  planPaymentRestrictionFeature?: PlanPaymentRestrictionFeature;
};

function DirectPromotionBadge(props: Props) {
  // https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=2613683821
  // see above for combination

  const planPayment = props.planPaymentRestrictionFeature?.managementName;
  const spPayment = props.salesPromotion?.paymentRestrictionFeature?.managementName;

  const isCombinationContradicting =
    planPayment === PLAN_PAYMENT_MANAGEMENT_NAME.CASH_ONLY &&
    spPayment === SP_PAYMENT_MANAGEMENT_NAME.AGENT_PAYMENT_ONLY;

  if (isCombinationContradicting) {
    return null;
  }

  // this is kept for posterity as TIDP-29793 makes it redundant
  // campaign feature prioritized over payment feature
  const isPaymentRestrictionPresent =
    spPayment === SP_PAYMENT_MANAGEMENT_NAME.AGENT_PAYMENT_ONLY ||
    spPayment === SP_PAYMENT_MANAGEMENT_NAME.ONSITE_PAYMENT_ONLY;

  return (
    <span
      className={cx(styles.discountValue, props.className)}
      data-testid="priceLabel-directPromotionBadge-wrapper"
    >
      {props.salesPromotion?.representativeFeatureName ||
        (isPaymentRestrictionPresent && props.salesPromotion?.paymentRestrictionFeature?.text)}
    </span>
  );
}

export default DirectPromotionBadge;
